import CloseIcon from "@mui/icons-material/Close";
import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import BasicDatePicker from "../../components/Comman/DatePickerEx";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const CountPopUp = ({
  handleCloses,
  open,
  countSummaryData,
  changeDate,
  dateForSalesTeamList,
}) => {
  const handleClose = () => {
    handleCloses();
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Count Summary
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid
            container
            justifyContent="flex-end"
            spacing={2}
            style={{ marginBottom: 16 }}
          >
            <Grid item>
              <BasicDatePicker
                color="primary"
                name="dateForSalesTeamList"
                size="small"
                value={dateForSalesTeamList}
                disabled={false}
                onChange={changeDate("dateForSalesTeamList")}
                style={{ width: 180 }}
              />
            </Grid>
          </Grid>
          {!(
            countSummaryData?.areaCount > 0 ||
            countSummaryData?.beatCount > 0 ||
            countSummaryData?.countryCount > 0 ||
            countSummaryData?.districtCount > 0 ||
            countSummaryData?.noticeCount > 0 ||
            countSummaryData?.offerCount > 0 ||
            countSummaryData?.outletCount > 0 ||
            countSummaryData?.productCount > 0 ||
            countSummaryData?.regionCount > 0 ||
            countSummaryData?.salesTeamCount > 0 ||
            countSummaryData?.stateCount > 0 ||
            countSummaryData?.stockHolderCount > 0 ||
            countSummaryData?.talukaCount > 0 ||
            countSummaryData?.transporterCount > 0 ||
            countSummaryData?.vehicleCount > 0 ||
            countSummaryData?.zoneCount > 0
          ) ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
                fontSize: "18px",
                fontWeight: "500",
                color: "#666",
              }}
            >
              No data found
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 10,
                width: "100%",
                marginTop: 15,
              }}
            >
              {/* Card 1: Country */}
              {countSummaryData?.countryCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.countryCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Country
                  </div>
                </div>
              )}

              {/* Card 2: State */}
              {countSummaryData?.stateCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.stateCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    State
                  </div>
                </div>
              )}

              {/* Card 3: Region */}
              {countSummaryData?.regionCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.regionCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Region
                  </div>
                </div>
              )}

              {/* Card 4: Zone */}
              {countSummaryData?.zoneCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.zoneCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Zone
                  </div>
                </div>
              )}

              {/* Card 5: Area */}
              {countSummaryData?.areaCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.areaCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Area
                  </div>
                </div>
              )}

              {/* Card 6: District */}
              {countSummaryData?.districtCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.districtCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    District
                  </div>
                </div>
              )}

              {/* Card 7: Taluka */}
              {countSummaryData?.talukaCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.talukaCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Taluka
                  </div>
                </div>
              )}

              {/* Card 8: Beat */}
              {countSummaryData?.beatCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.beatCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Beat
                  </div>
                </div>
              )}

              {/* Card 9: Outlet */}
              {countSummaryData?.outletCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.outletCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Outlet
                  </div>
                </div>
              )}

              {/* Card 10: Sales Team */}
              {countSummaryData?.salesTeamCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.salesTeamCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Sales Team
                  </div>
                </div>
              )}

              {/* Card 11: StockHolder */}
              {countSummaryData?.stockHolderCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.stockHolderCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    StockHolder
                  </div>
                </div>
              )}

              {/* Card 12: Transporter */}
              {countSummaryData?.transporterCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.transporterCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Transporter
                  </div>
                </div>
              )}

              {/* Card 13: Vehicle */}
              {countSummaryData?.vehicleCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.vehicleCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Vehicle
                  </div>
                </div>
              )}

              {/* Card 14: Notice */}
              {countSummaryData?.noticeCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.noticeCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Notice
                  </div>
                </div>
              )}

              {/* Card 15: Offer */}
              {countSummaryData?.offerCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.offerCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Offer
                  </div>
                </div>
              )}

              {/* Card 16: Product */}
              {countSummaryData?.productCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#dbeafe",
                    flex: "0 0 165px",
                    borderRadius: "3%",
                    padding: "12px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "16px", fontWeight: "500" }}>
                      {countSummaryData?.productCount}
                    </span>
                  </div>
                  <div
                    style={{
                      backgroundColor: "lightgray",
                      height: "1px",
                      width: "100%",
                    }}
                  ></div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      padding: "8px 0",
                      fontWeight: "500",
                      fontSize: "18px",
                    }}
                  >
                    Product
                  </div>
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CountPopUp);
